import {
  Box,
  Container,
  Paper,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import Layout from "../Layout";
import Loading from "../Loading";

import Title from "../Title";

import { useNavigate } from "react-router-dom";

import { useAlert } from "../../context/AlertContext";
import EmptyMessage from "../EmptyMessage";
import AlertDialog from "../AlertDialog";
import { useContent } from "../../content/useContent";

const classes = {
  center: {
    pt: 10,
    pb: 4,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minHeight: "100vh",
  },
};

type IProps = {
  name: string;
  pageLoading: boolean;

  item: any;

  editPath: any;

  handleDelete: any;
  openDeleteDialog: any;
  setOpenDeleteDialog: any;
  deleteLoading: any;
  itemRef: any;

  Card: any;
};

const ViewItem: React.FC<IProps> = ({
  name,
  pageLoading,

  item,
  editPath,

  handleDelete,
  openDeleteDialog,
  setOpenDeleteDialog,
  deleteLoading,
  itemRef,

  Card,
}) => {
  const navigate = useNavigate();
  const { msg, error } = useAlert();
  const { general } = useContent();

  if (error && msg) {
    return (
      <Layout>
        <Container sx={classes.center}>
          <Title title={`${name}`} />
          <EmptyMessage text={msg} />
        </Container>
      </Layout>
    );
  }

  return (
    <Layout>
      <Container sx={classes.center}>
        {pageLoading && <Loading />}

        {!pageLoading && !item && (
          <Box sx={{ height: "59vh" }}>
            <EmptyMessage text={` ${name} ${general.notFound}`} />
          </Box>
        )}

        {!pageLoading && item && (
          <Box sx={{ mt: 1, minHeight: "55vh", width: "100%" }}>
            <Paper sx={{ pt: 1, px: 2, pb: 2 }} elevation={2}>
              {Card}
            </Paper>

            <SpeedDial
              sx={{ position: "fixed", right: 20, bottom: 20 }}
              icon={<SpeedDialIcon />}
              ariaLabel={""}
            >
              <SpeedDialAction
                onClick={() => navigate(editPath)}
                icon={<EditIcon />}
                tooltipTitle={`${general.edit} ${name}`}
              />
              <SpeedDialAction
                onClick={() => setOpenDeleteDialog(true)}
                icon={<DeleteIcon />}
                tooltipTitle={`${general.delete} ${name}`}
              />
            </SpeedDial>

            <AlertDialog
              open={openDeleteDialog}
              handleClose={() => setOpenDeleteDialog(false)}
              onAgree={handleDelete}
              loading={deleteLoading}
              agreeText={general.delete}
              disagreeText={general.cancel}
              title={`${general.sureDelete} (${item[itemRef]})`}
            />
          </Box>
        )}
      </Container>
    </Layout>
  );
};

export default ViewItem;
